module.exports = __webpack_public_path__ + "media/assets/login/icon-signup-3-e5bb9cdc49d7196c977444f694918659.svg";